import AppContext from "PFApp/app_context";
import { useContext, useMemo } from "react";

export const useSkillsType = () => {
  const {
    store: { currentProfile }
  } = useContext(AppContext);

  return useMemo(() => currentProfile.custom_types.find(({ name }) => name === "skills"), [currentProfile]);
};
